import * as React from 'react';
import { ColumnFeatures } from '../ColumnFeatures';
import { PricingPlanSection } from './PricingPlanSection';
import { v4PlanPrices } from '../../../../constants/pricing';
import { CustomPlanColumnSubtitle } from '../CustomPlanColumnSubtitle';
import { TrialPlanColumnSubtitle } from '../TrialPlanColumnSubtitle';
import { StandardPlanColumnSubtitle } from '../StandardPlanColumnSubtitle';

interface PricingColumnProps {
  seatCount: number;
  setSeatCount: (seatCount: number) => void;
  columnData: Record<string, any>;
  togglePayPeriod: string;
}
export const PricingColumn = ({
  seatCount, setSeatCount, columnData, togglePayPeriod,
}: PricingColumnProps) => {
  const { id, name, nameColor, featureSections } = columnData;
  const handleSeatChange = (count) => setSeatCount(count);
  const isCustomPlan = id === 'custom';
  const isStandardPlan = id === 'standard-plan-4';
  const isTrialPlan = id === 'trial-plan-4';

  const emptyPlaceholder = <div style={{ minHeight: '23px' }} />;
  const buttonClassName = 'button align-self-c lg mt-10 bright-green width-100';
  const containerClassName = `plan-container ${isStandardPlan ? 'pop' : ''}`;

  let bigPrice;
  let selectButton;
  let perMonth;
  let perUser;
  let subtitle;

  if (!isCustomPlan) {
    const key = isTrialPlan ? id : `${id}-${togglePayPeriod}`;
    const planPrices = v4PlanPrices[key];

    bigPrice = (
      <span className="black fsz-30 bold-800">
        $
        {planPrices.seatPrice}
      </span>
    );
    perMonth = <span className="black fsz-16 bold-800">/mo</span>;
    perUser = <span className="fsz-16">&nbsp;per user</span>;

    selectButton = (
      <a type="button" className={buttonClassName} href="/signup">
        Start Free Trial
      </a>
    );

    if (isTrialPlan) {
      subtitle = <TrialPlanColumnSubtitle />;
    } else if (isStandardPlan) {
      subtitle = <StandardPlanColumnSubtitle togglePayPeriod={togglePayPeriod} />;
    }
  } else {
    subtitle = <CustomPlanColumnSubtitle />;
    bigPrice = <span className="black fsz-30 bold-800">Custom</span>;
    selectButton = (
      <a className={buttonClassName} href="/enterprise">Contact Us</a>
    );
  }

  const popularHeader = !isStandardPlan ? emptyPlaceholder : <div className="popular">MOST POPULAR</div>;
  const planNameClass = `${nameColor} center fsz-20 uppercase letter-space-3 mt-15`;
  const planPrice = isTrialPlan ? (
    <span className="black fsz-30 bold-800">Free</span>
  ) : (
    <>
      {bigPrice}
      {perMonth}
      {perUser}
    </>
  );

  return (
    <div className="column">
      <div className={containerClassName}>
        <div className="container-top">
          <div className="row-1">
            {popularHeader}
            <h2 className={planNameClass}>{name}</h2>
            <div className="subscription-fees flex-col my-25">
              <div className="align-self-c">{planPrice}</div>
              {subtitle}
            </div>
            <PricingPlanSection
              planId={id}
              handleSeatChange={handleSeatChange}
              seatCount={seatCount}
              togglePayPeriod={togglePayPeriod}
              planName={name}
            />
          </div>
          {selectButton}
        </div>
      </div>
      <div>
        <ColumnFeatures featureSections={featureSections} />
        <br />
        <p>And more</p>
      </div>
    </div>
  );
};
